export default __webpack_public_path__ + "4112db510105a96c4eb106f24398b333.svg";